import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'info'

export const toastQueue = ref<{ id: number; message: string; type: ToastType }[]>([])

let toastId = 0
type ToastOptions = {
  type?: ToastType
  timeoutMs?: number
}
export function toast(message: string, options?: ToastOptions) {
  toastId += 1
  const newToast = { id: toastId, message: message, type: options?.type ?? 'info' }
  toastQueue.value.push(newToast)
  setTimeout(
    () => {
      toastQueue.value = toastQueue.value.filter((t) => t.id != toastId)
    },
    options?.timeoutMs ? options.timeoutMs : 3000,
  )
}
